import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import "./SearchBox.scss";

function SearchBox() {
  const manualType = useSelector((state) => state.manualTypeChecker.manualType);
  const [value, setValue] = useState("");

  // const history = useHistory();
  const navigate = useNavigate();

  const onChange = (e) => setValue(e.target.value);
  const onSubmit = (e) => {
    e.preventDefault();

    if (value !== "") {
      setValue("");

      navigate(`/${manualType}/searchpage/${value}`);

      // document.getElementById("sidemenu-toggle").checked = false;
      // document.getElementById("sidemenu-checkbox").checked = false;
    }
  };

  return (
    <>
      <div className="component-searchdiv">
        <form onSubmit={onSubmit} className="component-inputform">
          <input
            className="component-searchbox-input"
            placeholder="검색어 입력 후, Enter를 누르세요"
            onChange={onChange}
            value={value}
          />
        </form>
      </div>
    </>
  );
}

export default SearchBox;
